import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl, HvlQueryModel } from '@hvlng/framework-bff/core';

@JsonObject('KovanHrPerPersonnelSearchQueryModel')
export class PerPersonnelSearchQueryModel extends HvlQueryModel {
    @EmptyControl()
    @JsonProperty('searchParam', String, true)
    searchParam: string = null;

    @EmptyControl()
    @JsonProperty('hrmPerPeopleId', Number, true)
    hrmPerPeopleId: number = null;

    @EmptyControl()
    @JsonProperty('orgHrmPerObjectDefId', Number, true)
    orgHrmPerObjectDefId: number = null;

    @EmptyControl()
    @JsonProperty('posHrmPerObjectDefId', Number, true)
    posHrmPerObjectDefId: number = null;

    @EmptyControl()
    @JsonProperty('onlySubEmployee', Boolean, true)
    onlySubEmployee: boolean = null;

    @EmptyControl()
    @JsonProperty('authorizationRoleTypeCodeList', [String], true)
    authorizationRoleTypeCodeList: Array<string> = new Array<string>();
    @EmptyControl()
    @JsonProperty('showPassivePersonnels', Boolean, true)
    showPassivePersonnels: boolean = false;

    @EmptyControl()
    @JsonProperty('employeeTypeUuidList', [String], true)
    employeeTypeUuidList: Array<string> = new Array<string>();

    @EmptyControl()
    @JsonProperty('organizationHrmPerServiceClassCodeList', [String], true)
    organizationHrmPerServiceClassCodeList: string[] = [];

    @EmptyControl()
    @JsonProperty('minServiceClassOrderLevel', Number, true)
    minServiceClassOrderLevel: number = null;

    @EmptyControl()
    @JsonProperty('searchParamReverseSearchMode', Boolean, true)
    searchParamReverseSearchMode: boolean = null;
}
